import './continerPrice.css';
import Converter from '../../../../../functions/Converter';


export default ({price, r_price, places}) => {


    return (<>

    {
        places > 0 ? (
            <div className='continer-price'>
            <div>
                <p> <Converter num={price} /> </p>
                <p> <Converter num={r_price} /> </p>
            </div>

            <div>
                <p> {places > 10 ? 10 : places} מקומות </p>
            </div>
        </div>
        ) : (
            <p className={'continer-price-sold-out'}>אזלו המקומות</p>
        )
    }

    </>)
} 